<template>
  <section>
    <section class="pb-4">
      <nav class="columns">
        <div class="column is-narrow" style="width: 100%;">
          <div class="column is-narrow" style="text-align: right;">
            <b-dropdown
              v-if="isApplyMode"
              :triggers="['hover']"
              aria-role="list"
              class="ml-4"
            >
              <template #trigger>
                <b-button
                  :loading="sending"
                  type="is-primary"
                  position="is-bottom-left"
                  icon-left="plus"
                  icon-right="menu-down"
                >
                  {{
                    $t('attributes.gift_application') + $t('attributes.gift')
                  }}
                </b-button>
              </template>

              <b-dropdown-item
                v-for="option in typeOptions"
                :key="option.value"
                aria-role="listitem"
                :disabled="!typeEnabled(option.value)"
                @click="onAdd(option.value)"
              >
                <div class="media">
                  <div class="media-content">
                    <h3>{{ option.name }}</h3>
                  </div>
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </nav>
      <b-tabs size="is-medium">
        <b-tab-item v-if="isApplyMode" label="贈品列表" icon="wallet-giftcard">
          <gift-menu />
        </b-tab-item>
        <b-tab-item label="申請紀錄" icon="view-list">
          <nav class="columns">
            <div class="column">
              <b-field grouped group-multiline>
                <b-field>
                  <p class="control">
                    <span class="button is-static">
                      {{ $t('attributes.gift_application_submit_date') }}
                    </span>
                  </p>
                  <b-datepicker
                    :placeholder="
                      $t('message.please_select') + $t('attributes.date_range')
                    "
                    v-model="selectedDates"
                    range
                    @input="onSelectedDates"
                  >
                    <div class="buttons">
                      <b-button
                        :label="$t('attributes.this_month')"
                        type="is-success"
                        size="is-small"
                        @click="onSelectThisMonth"
                      />
                      <b-button
                        :label="$t('attributes.last_month')"
                        type="is-info"
                        size="is-small"
                        @click="onSelectLastMonth"
                      />
                      <b-button
                        :label="$t('attributes.three_month')"
                        type="is-warning"
                        size="is-small"
                        @click="onSelectThreeMonth"
                      />
                    </div>
                  </b-datepicker>
                </b-field>

                <b-field>
                  <p class="control">
                    <span class="button is-static">
                      {{ $t('attributes.gift_application_type') }}
                    </span>
                  </p>
                  <b-select v-model="filterType" @input="onFilter">
                    <option value="">{{ $t('attributes.all') }}</option>
                    <option
                      v-for="option in typeOptions"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.name }}
                    </option>
                  </b-select>
                </b-field>

                <b-field class="pt-2">
                  <p class="control">
                    <span class="mr-1">
                      {{ $t('attributes.status') + ':' }}
                    </span>
                  </p>
                  <b-checkbox
                    v-model="filterStates"
                    v-for="option in stateOptions"
                    type="is-info"
                    :key="option.value"
                    :native-value="option.value"
                    @input="onFilter"
                  >
                    {{ option.name }}
                  </b-checkbox>
                </b-field>
              </b-field>

              <b-field grouped group-multiline class="mt-5">
                <b-field>
                  <b-input
                    v-model="searchNumber"
                    :placeholder="
                      $t('attributes.search') +
                        $t('attributes.gift_application_number')
                    "
                    type="search"
                    icon="magnify"
                    clearable
                    @input="onFilter"
                    style="width: 160px"
                  ></b-input>
                </b-field>

                <b-field>
                  <b-input
                    v-model="search"
                    :placeholder="
                      $t('attributes.search') + $t('attributes.gift')
                    "
                    type="search"
                    icon="magnify"
                    clearable
                    @input="onFilter"
                    style="width: 160px"
                  ></b-input>
                </b-field>

                <b-field>
                  <b-autocomplete
                    v-model="userSearch"
                    name="search_user"
                    field="display_name"
                    :data="users"
                    :loading="isLoadingUsers"
                    placeholder="搜尋會員名稱/身分證號碼/電話"
                    :open-on-focus="false"
                    clearable
                    @typing="loadUsers"
                    @select="onSelectUser"
                    style="width: 250px"
                  >
                    <template #default="props">
                      <p>
                        {{ props.option.identity }} -
                        <span>{{ props.option.display_name }}</span> -
                        <span>{{ props.option.phone_number }}</span>
                      </p>
                    </template>
                    <template #empty>
                      {{
                        userSearch
                          ? isLoadingUsers
                            ? $t('attributes.searching')
                            : $t('attributes.not_found')
                          : '搜尋會員名稱/身分證號碼/電話'
                      }}
                    </template>
                  </b-autocomplete>
                </b-field>

                <b-field style="max-width: 100%">
                  <b-input
                    v-model="group_code"
                    :placeholder="
                      $t('attributes.search') + $t('attributes.group_code')
                    "
                    type="search"
                    icon="magnify"
                    clearable
                    style="width: 250px"
                    @input="onFilter"
                  ></b-input>
                </b-field>

                <b-field>
                  <b-autocomplete
                    v-model="employeeSearch"
                    name="search_employee"
                    field="name"
                    :data="employees"
                    :loading="isLoadingEmployees"
                    placeholder="搜尋業務或申請人編號/姓名"
                    :open-on-focus="false"
                    clearable
                    @typing="loadEmployees"
                    @select="onSelectEmployee"
                    style="width: 240px"
                  >
                    <template #default="props">
                      <p>
                        {{ props.option.emp_code }} -
                        <span v-html="props.option.name"></span>
                      </p>
                    </template>
                    <template #empty>
                      {{
                        employeeSearch
                          ? isLoadingEmployees
                            ? $t('attributes.searching')
                            : $t('attributes.not_found')
                          : '搜尋業務或申請人編號/姓名'
                      }}
                    </template>
                  </b-autocomplete>
                </b-field>
              </b-field>
            </div>
            <div class="column is-narrow">
              <b-button :loading="sending" type="is-link" @click="onSearch">
                {{ $t('attributes.search') }}
              </b-button>
            </div>
            <div class="column is-narrow">
              <b-button
                v-if="mode === 'review'"
                :loading="sending"
                type="is-info"
                @click.prevent="onReviewCancel"
              >
                {{ $t('attributes.gift_review_cancel') }}
              </b-button>
            </div>
            <div class="column is-narrow">
              <b-button
                v-if="!isApplyMode"
                :loading="sending"
                type="is-info"
                @click="onExport"
              >
                {{ $t('message.export_reports') + '(同團合併)' }}
              </b-button>
            </div>
          </nav>
          <nav>
            <div
              class="column is-narrow"
              v-if="!isApplyMode"
              style="max-width: 1380px; margin:0 auto; letter-spacing: 0.3rem;"
            >
              <b-message
                :type="lockReviewsCount > 0 ? 'is-danger' : 'is-success'"
                size="is-medium"
                has-icon
              >
                {{ hasLockReviewsText }}
              </b-message>
            </div>
          </nav>
          <div style="max-width: 1380px; margin:0 auto;">
            <b-table
              :data="items"
              checked-rows.sync="selectedItem"
              :loading="loadingItems"
              :mobile-cards="false"
              checkable
              hoverable
              scrollable
              narrowed
              backend-sorting
              sticky-header
              width="620px"
              height="620px"
              :row-class="rowClass"
              :default-sort-direction="defaultSortOrder"
              :default-sort="[sortField, sortOrder]"
              @sort="onSort"
              @check="onSelected"
              @check-all="onSelected"
            >
              <b-table-column
                field="created_at"
                :label="$t('attributes.gift_application_submit_date')"
                width="120"
                sortable
                centered
                header-class="nowrap"
                cell-class="nowrap"
                v-slot="props"
              >
                {{ formatDate(props.row.created_at) }}
              </b-table-column>

              <b-table-column
                v-if="!isApplyMode"
                field="review_number"
                :label="$t('attributes.gift_application_review_number')"
                width="130"
                sortable
                centered
                header-class="nowrap"
                cell-class="nowrap"
                v-slot="props"
              >
                {{ props.row.number }}
              </b-table-column>

              <b-table-column
                field="review_date"
                :label="$t('attributes.gift_application_review_date')"
                width="120"
                sortable
                centered
                header-class="nowrap"
                cell-class="nowrap"
                v-slot="props"
              >
                {{ formatDate(props.row.review_date) || '-' }}
              </b-table-column>

              <b-table-column
                field="group_code"
                :label="$t('attributes.group_code')"
                width="130"
                v-slot="props"
              >
                <span v-html="props.row.group_code"></span>
              </b-table-column>
              <b-table-column
                field="state"
                :label="$t('attributes.gift_application_state')"
                width="100"
                sortable
                centered
                header-class="nowrap"
                cell-class="nowrap"
                v-slot="props"
              >
                {{ stateName(props.row.state) }}
                <span class="has-text-danger">
                  {{ returnState(props.row) }}
                </span>
                <span v-if="props.row.lock" class="has-text-danger">
                  (鎖定)
                </span>
              </b-table-column>

              <b-table-column
                field="apply_type"
                :label="$t('attributes.gift_application_type')"
                width="100"
                sortable
                centered
                header-class="nowrap"
                cell-class="nowrap"
                v-slot="props"
              >
                {{ applyTypeName(props.row.apply_type) }}
              </b-table-column>

              <b-table-column
                v-if="isReviewMode"
                field="operator_name"
                :label="$t('attributes.gift_review_operator')"
                sortable
                header-class="nowrap"
                cell-class="nowrap"
                v-slot="props"
              >
                [{{ props.row.operator_code }}] {{ props.row.operator_name }}
              </b-table-column>

              <b-table-column
                field="sales_name"
                :label="$t('attributes.gift_review_sales')"
                sortable
                header-class="nowrap"
                cell-class="nowrap"
                v-slot="props"
              >
                [{{ props.row.sales_code }}] {{ props.row.sales_name }}
              </b-table-column>

              <b-table-column
                field="amount"
                :label="$t('attributes.gift_review_amount')"
                width="100"
                sortable
                numeric
                header-class="nowrap"
                cell-class="nowrap"
                v-slot="props"
              >
                {{ formatCurrency(props.row.amount) }}
              </b-table-column>
              <b-table-column
                :label="$t('attributes.function')"
                width="150"
                centered
                v-slot="props"
              >
                <div class="buttons is-centered">
                  <b-button
                    type="is-info"
                    @click.stop.prevent="showDetail(props.row)"
                  >
                    {{ $t('attributes.detail_info') }}
                  </b-button>
                </div>
              </b-table-column>
              <template #empty>
                <section class="section">
                  <div
                    v-if="!loadingItems"
                    class="content has-text-grey has-text-centered"
                  >
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large" />
                    </p>
                  </div>
                </section>
              </template>
            </b-table>
          </div>
        </b-tab-item>
      </b-tabs>
    </section>

    <b-modal
      :active.sync="showItem"
      :can-cancel="['escape', 'x']"
      has-modal-card
    >
      <review-item
        v-if="selectedItem"
        :number="selectedItem.number"
        :reload_key="reload_item_key"
        :mode="mode"
        :loading.sync="loadingReview"
        :sending.sync="sending"
        @audited="onAudited"
        @rejected="onRejected"
        @canceled="onCanceled"
        @deleted="onDeleted"
        @void="onVoid"
        @clone="onClone"
        @return="onReturn"
      />
    </b-modal>

    <b-modal
      :active.sync="isFormModalActive"
      has-modal-card
      full-screen
      :can-cancel="false"
      destroy-on-hide
    >
      <review-create-form
        :type="addType"
        :review="editingItem"
        @saved="OnSaved"
        @cancel="OnCancel"
      ></review-create-form>
    </b-modal>

    <b-modal
      :active.sync="isReturnFormModalActive"
      :can-cancel="['escape', 'x']"
      has-modal-card
    >
      <review-return-form
        :review="editingItem"
        @saved="OnReturned"
        @cancel="OnCancel"
      ></review-return-form>
    </b-modal>
    <b-loading :active="sending" :is-full-page="true" :can-cancel="false" />

    <b-modal
      :active.sync="isCancelFormModalActive"
      has-modal-card
      :can-cancel="false"
    >
      <review-cancel-form
        :sending="sending"
        @send="cancel"
        @cancel="OnCancel"
      ></review-cancel-form>
    </b-modal>
  </section>
</template>

<script>
import { EMPLOYEES_API, USER_API, GIFT_REVIEWS_API } from '@/utils/apis'
import { GIFT_REVIEW_STATE_TYPES } from '@/utils/constants'
import debounce from 'lodash/debounce'
import notifyService from '@/services/notifyService'
import GiftReviewMixin from '@/mixins/GiftReviewMixin'
import ReviewItem from '@/components/gifts/Review'
import ReviewCreateForm from '@/components/gifts/ReviewCreateForm'
import ReviewReturnForm from '@/components/gifts/ReviewReturnForm'
import GiftMenu from '@/components/gifts/GiftMenu'
import ReviewCancelForm from '@/components/gifts/ReviewCancelForm.vue'

export default {
  name: 'ReviewList',
  mixins: [GiftReviewMixin],
  components: {
    ReviewCancelForm,
    ReviewItem,
    ReviewCreateForm,
    ReviewReturnForm,
    GiftMenu
  },

  props: {
    query: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: true,
      validator(value) {
        return ['review', 'apply'].includes(value)
      }
    }
  },
  data() {
    const { startDate, endDate } = this.calculateDateRange(this.query)

    return {
      isApplyMode: this.mode === 'apply',
      isReviewMode: this.mode === 'review',

      loadingItems: false,
      items: [],
      total: 0,
      selectedItems: null,
      selectedItem: null,
      showItem: false,
      reload_item_key: 1,
      loadingReview: false,

      isLoadingGroups: false,
      groups: [],
      group_code: null,

      isLoadingUsers: false,
      users: [],
      userSearch: null,

      isLoadingEmployees: false,
      employees: [],
      employeeSearch: null,

      filterType: this.query.type || '',
      filterStates: this.query.states
        ? this.query.states.split(',')
        : [
            GIFT_REVIEW_STATE_TYPES.PENDING,
            GIFT_REVIEW_STATE_TYPES.AUDIT,
            GIFT_REVIEW_STATE_TYPES.LOCK
          ],
      group: this.query.g || '',
      user: this.query.u || '',
      employee: this.query.e || '',
      search: this.query.search || '',
      searchNumber: this.query.searchNumber || '',

      selectedDates: [startDate, endDate],
      startDate,
      endDate,

      sortField: this.query.sort || 'created_at',
      sortOrder: this.query.order || 'desc',
      defaultSortOrder: 'desc',
      page: parseInt(this.query.page) || 1,
      perPage: this.query.page_size || 10,

      sending: false,

      addType: '',
      editingItem: null,
      isFormModalActive: false,
      isReturnFormModalActive: false,

      isCancelFormModalActive: false,

      hasLockReviewsText: '',
      lockReviewsCount: 1
    }
  },
  watch: {
    query(query) {
      this.getQuery(query)
    }
  },
  computed: {
    isLoading() {
      return this.loadingItems || this.loadingReview
    }
  },
  mounted() {
    this.getLockReviews()
  },
  methods: {
    async getLockReviews() {
      try {
        const api = `${GIFT_REVIEWS_API}/lock-reviews`
        this.loadingItems = true
        const res = await this.axios.get(api)
        const data = res.data.data
        this.lockReviewsCount = data.count
        this.hasLockReviewsText =
          data.count > 0
            ? '截至' +
              data.date +
              '，仍有' +
              data.count +
              '筆申請單應銷帳未銷帳，請銷帳!!'
            : '截至' + data.date + '申請單皆已銷帳'
      } catch (e) {
        notifyService.fetch_error('gift_review', e)
      } finally {
        this.loadingItems = false
      }
    },
    async onSearch() {
      try {
        this.items = []
        const api = `${GIFT_REVIEWS_API}`
        const params = {
          type: this.filterType,
          states: this.filterStates.join(','),
          group: this.group_code,
          user: this.user,
          employee: this.employee,
          search: this.search,
          number: this.searchNumber,
          start_date: this.formatDate(this.startDate),
          end_date: this.formatDate(this.endDate),
          sort_by: this.sortField,
          by_descending: this.sortOrder !== 'asc',
          page_size: this.perPage,
          page_number: this.page
        }

        this.loadingItems = true
        const res = await this.axios.get(api, { params })
        const data = res.data.data

        if (this.selectedItem) {
          this.selectedItem = data.items.find(
            a => a.number === this.selectedItem.number
          )
          this.reload_item_key++
        }
        this.items = data.items
        this.total = data.item_count
      } catch (e) {
        this.selectedItem = null
        this.items = []
        this.total = 0

        notifyService.fetch_error('gift_review', e)
      } finally {
        this.loadingItems = false
      }
    },
    onSelected(item) {
      const list = item.map(t => t.number)
      this.selectedItems = this.items.filter(x => list.includes(x.number))
    },
    showDetail(item) {
      this.selectedItem = item
      this.showItem = true
    },
    async loadUsersAsync() {
      const api = `${USER_API}/search`
      const params = {
        search: this.userSearch
      }

      this.isLoadingUsers = true
      try {
        const res = await this.axios.get(api, { params })
        this.users = res.data.data
      } catch (e) {
        this.users = []

        notifyService.fetch_error('user', e)
      } finally {
        this.isLoadingUsers = false
      }
    },
    loadUsers: debounce(function() {
      if (!this.userSearch) {
        this.users = []
        return
      }

      this.loadUsersAsync()
    }, 1000),
    onSelectUser(option) {
      this.user = option && option.id
      this.page = 1
      this.updateQuery()
    },
    async loadEmployeesAsync() {
      const api = `${EMPLOYEES_API}/search`
      const params = {
        search: this.employeeSearch
      }

      this.isLoadingEmployees = true
      try {
        const res = await this.axios.get(api, { params })
        this.employees = res.data.data
      } catch (e) {
        this.employees = []

        notifyService.fetch_error('employee', e)
      } finally {
        this.isLoadingEmployees = false
      }
    },
    loadEmployees: debounce(function() {
      if (!this.employeeSearch) {
        this.employees = []
        return
      }

      this.loadEmployeesAsync()
    }, 1000),
    onSelectEmployee(option) {
      this.employee = option && option.emp_code
      this.page = 1
      this.updateQuery()
    },
    getQuery(query) {
      this.filterType = query.type || ''
      this.filterStates = query.states
        ? query.states.split(',')
        : [GIFT_REVIEW_STATE_TYPES.PENDING, GIFT_REVIEW_STATE_TYPES.AUDIT]
      this.group = query.g
      this.user = query.u
      this.employee = query.e
      this.search = query.search
      this.searchNumber = query.number
      this.sortField = query.sort || 'created_at'
      this.sortOrder = query.order || 'desc'
      this.page = parseInt(query.page) || 1
      this.perPage = query.page_size || 10

      const { startDate, endDate } = this.calculateDateRange(query)
      this.startDate = startDate
      this.endDate = endDate
      this.selectedDates = [startDate, endDate]
    },
    updateQuery() {
      const query = {
        type: this.filterType,
        states: this.filterStates.join(','),
        g: this.group_code,
        u: this.user,
        e: this.employee,
        search: this.search,
        number: this.searchNumber,
        start: this.startDate && this.$dayjs(this.startDate).unix(),
        end: this.endDate && this.$dayjs(this.endDate).unix(),
        sort: this.sortField,
        order: this.sortOrder,
        page_size: this.perPage.toString(),
        page: this.page.toString()
      }

      Object.keys(query).forEach(key => !query[key] && delete query[key])

      this.$router
        .push({
          name: this.$route.name,
          query: query
        })
        .catch(() => {})
      this.onSearch()
    },
    calculateDateRange(query) {
      let startDate = null
      let endDate = null

      if (query.start && query.end) {
        startDate = this.$dayjs.unix(query.start).toDate()
        endDate = this.$dayjs.unix(query.end).toDate()
      } else {
        const today = this.$dayjs()
        startDate = today
          .subtract(3, 'month')
          .startOf('month')
          .toDate()
        endDate = today.toDate()
      }

      return { startDate, endDate }
    },
    onSelectedDates() {
      this.startDate = this.selectedDates[0]
      this.endDate = this.selectedDates[1]

      this.page = 1
      this.updateQuery()
    },
    onSelectThreeMonth() {
      const today = this.$dayjs()
      this.startDate = today
        .subtract(3, 'month')
        .startOf('month')
        .toDate()
      this.endDate = today.toDate()
      this.selectedDates = [this.startDate, this.endDate]

      this.updateQuery()
    },
    onSelectLastMonth() {
      const day = this.$dayjs()
        .startOf('month')
        .subtract(1, 'day')
      this.selectMonth(day)
    },
    onSelectThisMonth() {
      const today = this.$dayjs()
      this.selectMonth(today)
    },
    selectMonth(day) {
      this.startDate = day.startOf('month').toDate()
      this.endDate = day.endOf('month').toDate()
      this.selectedDates = [this.startDate, this.endDate]

      this.page = 1
      this.updateQuery()
    },
    onClearDates() {
      this.startDate = null
      this.endDate = null
      this.selectedDates = []

      this.page = 1
      this.updateQuery()
    },
    onFilter: debounce(function() {
      this.page = 1
      this.updateQuery()
    }, 500),
    onPageChange(page) {
      this.page = page
      this.updateQuery()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.updateQuery()
    },
    onAudited() {
      this.onSearch()
    },
    onRejected() {
      this.onSearch()
    },
    onCanceled() {
      this.onSearch()
    },
    onVoid() {
      this.onSearch()
    },
    onDeleted() {
      this.onSearch()
    },
    onAdd(type) {
      this.addType = type
      this.editingItem = {
        sales_code: null,
        sales_name: null,
        sales_department: null,
        applications: []
      }
      this.isFormModalActive = true
    },
    onReturn(item) {
      this.isReturnFormModalActive = true
      this.editingItem = item
    },
    onClone(item) {
      this.addType = item.apply_type
      this.editingItem = {
        sales_code: item.sales_code,
        sales_name: item.sales_name,
        sales_department: item.department_no,
        applications: item.applications.map(app => {
          return {
            id: app.id,
            is_edit: false,
            status: '',
            is_public: app.is_public,
            user_id: app.user_id,
            user_identity: app.user_identity,
            user_name: app.user_name,
            user_phone: app.user_phone,
            group_code: app.group_code,
            group_name: app.group_name,
            group_departure_date: app.group_departure_date,
            gifts: app.items.map(gift => ({
              id: gift.gift_id,
              quantity: gift.quantity
            })),
            amount: app.amount,
            remark: app.remark
          }
        })
      }
      this.isFormModalActive = true
    },
    onDelete(item) {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        type: 'is-danger',
        cancelText: this.$t('attributes.cancel'),
        confirmText: this.$t('attributes.delete'),
        onConfirm: () => {
          this.deleteItem(item)
        }
      })
    },

    OnSaved() {
      this.isFormModalActive = false
      this.onSearch()
    },
    OnReturned() {
      this.isReturnFormModalActive = false
      this.onSearch()
    },
    OnCancel() {
      this.isFormModalActive = false
      this.isReturnFormModalActive = false
      this.isCancelFormModalActive = false
    },

    async onExport() {
      let verify = true
      let errorMessage = ''
      if (this.selectedItems === null) {
        errorMessage = '至少選擇一筆資料!'
        verify = false
      }
      this.selectedItems.forEach(function(item) {
        if (item.state !== 'audit') {
          errorMessage = '選擇的資料必須是"審核通過"狀態!'
          verify = false
        }
      })
      if (!verify) {
        this.$buefy.dialog.alert({
          title: '匯出失敗',
          message: errorMessage,
          confirmText: '確定'
        })
        return
      }

      this.$buefy.dialog.confirm({
        message: '是否匯出資料?',
        confirmText: '是',
        cancelText: '否',
        onConfirm: () => this.exporting(),
        onCancel: () => {
          return false
        }
      })
    },
    async exporting() {
      try {
        this.sending = true
        const api = `${GIFT_REVIEWS_API}/export`
        let items = ''
        Object.values(this.selectedItems).forEach(item => {
          items += item.number + ','
        })
        items = items.substring(0, items.length - 1)

        const data = { numbers: items }
        const config = {
          headers: { Accept: 'application/vnd.ms-excel' },
          responseType: 'blob',
          errorHandle: {
            customMessage: `${this.$t('attributes.fetch_failed', [
              this.$t('attributes.order')
            ])}: `
          }
        }
        this.loading = true
        const response = await this.axios.post(api, data, config)

        const date = this.$dayjs().format('YYYYMMDDHHmmss')
        const fileName = `贈品申請審核列表_${date}`

        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        this.onSearch()
      } catch (e) {
        notifyService.error('下載失敗', e)
      } finally {
        this.sending = false
      }
    },
    async deleteItem(item) {
      try {
        const api = `${GIFT_REVIEWS_API}/${item.id}`

        this.sending = true
        await this.axios.delete(api)

        notifyService.success(this.$t('attributes.delete_succeed'))

        await this.onSearch()
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.sending = false
      }
    },

    rowClass(item) {
      let selected = false
      if (this.selectedItem) {
        selected = this.selectedItem.number === item.number
      }

      if (selected) {
        switch (item.state) {
          case GIFT_REVIEW_STATE_TYPES.PENDING:
            return 'has-background-danger'
          case GIFT_REVIEW_STATE_TYPES.AUDIT:
            return 'has-background-info'
          case GIFT_REVIEW_STATE_TYPES.REJECT:
            return 'has-background-warning-dark'
          case GIFT_REVIEW_STATE_TYPES.CANCEL:
            return 'has-background-success'
          case GIFT_REVIEW_STATE_TYPES.VOID:
            return 'has-background-grey'
        }
      } else {
        switch (item.state) {
          case GIFT_REVIEW_STATE_TYPES.PENDING:
            return 'has-background-danger-light'
          case GIFT_REVIEW_STATE_TYPES.AUDIT:
            return 'has-background-info-light'
          case GIFT_REVIEW_STATE_TYPES.REJECT:
            return 'has-background-warning-light'
          case GIFT_REVIEW_STATE_TYPES.CANCEL:
            return 'has-background-success-light'
          case GIFT_REVIEW_STATE_TYPES.VOID:
            return 'has-text-grey-dark has-background-white-ter'
        }
      }
    },
    onReviewCancel() {
      const thisObject = this
      let verify = true
      if (!this.selectedItems || this.selectedItems.length <= 0) {
        thisObject.$buefy.dialog.alert('銷帳失敗，至少選擇一筆申請紀錄!!')
        return
      }
      this.selectedItems.forEach(function(item) {
        if (item.state !== 'lock' && verify) {
          thisObject.$buefy.dialog.alert(
            '銷帳失敗，選擇的申請紀錄必須是「待銷帳」狀態!!'
          )
          verify = false
        }
      })
      thisObject.isCancelFormModalActive = verify
    },
    async cancel(data) {
      if (!this.selectedItems || this.selectedItems.length <= 0) {
        this.$buefy.dialog.alert('銷帳失敗，至少選擇一筆申請紀錄!!')
        return
      }

      try {
        this.sending = true
        let numbers = ''
        this.selectedItems.forEach(function(item) {
          numbers += item.number + ','
        })
        numbers = numbers.substring(0, numbers.length - 1)
        data.review_numbers = numbers
        this.$emit('update:sending', true)

        const api = `${GIFT_REVIEWS_API}/cancel`
        await this.axios.put(api, data)
        await this.onSearch()
        await this.getLockReviews()

        notifyService.success(this.$t('attributes.cancel_succeed'))

        this.$emit('canceled')
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.isCancelFormModalActive = false
        this.sending = false
        this.$emit('update:sending', false)
      }
    }
  }
}
</script>
